(function($){

    //Global variables
    var viewportwidth,
        viewportheight;

    function getWindowSize(){
        if (typeof window.innerWidth != 'undefined'){
            viewportwidth = window.innerWidth,
            viewportheight = window.innerHeight
        }else if (typeof document.documentElement != 'undefined' && typeof document.documentElement.clientWidth != 'undefined' && document.documentElement.clientWidth != 0){
            viewportwidth = document.documentElement.clientWidth,
            viewportheight = document.documentElement.clientHeight
        }else{
            viewportwidth = document.getElementsByTagName('body')[0].clientWidth,
            viewportheight = document.getElementsByTagName('body')[0].clientHeight
        }
    }

    (function($){

    $.fn.extend({

        addTemporaryClass: function(className, duration) {
                var elements = this;
                setTimeout(function() {
                    elements.removeClass(className);
                }, duration);

                return this.each(function() {
                    $(this).addClass(className);
                });
            }
        });

    })(jQuery);


    function initSlider() {
        var sliders = $('.slider'),
            slideCount = '',
            visibleSlides = '';

        sliders.each(function(idx) {
            var sliderId = "slider" + idx,
                slides = $(this).children();

            this.id = sliderId;

            slideCount = slides.length;

            if (slideCount >= 3) {
                visibleSlides = 2.75;
            } else if (slideCount == 2) {
                visibleSlides = 2;
            } else {
                visibleSlides = 1;
            }

            //console.log(visibleSlides);

            $(this).slick({
                dots: false,
                arrows: true,
                infinite: false,
                speed: 500,
                slidesToShow: visibleSlides,
                slidesToScroll: 1,
                adaptiveHeight: true,
                prevArrow: $('.slider__prev'),
                nextArrow: $('.slider__next'),
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        })

        var hpslider = $('.hero--slider');

        hpslider.slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 1300,
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            cssEase: 'linear'
        }).slick("slickPause");

        var initialDelay = 3000;

        setTimeout(function() {
            hpslider.slick("slickPlay");
        },initialDelay);
    }

    function initMobile() {
        var productHeight = $('#site-navigation li.has-products ul li').height();

        $('#site-navigation li.item').on('hover', function(){

            $(this).toggleClass('hover');

            if($(this).is('.has-products')){

                var firstFlyoutHeight = $(this).find('ul li .item').children('.flyout').first().height();

                $(this).find('ul li').children('.item').removeClass('active').first().addClass('active');

                if(firstFlyoutHeight > productHeight){
                    $(this).find('ul').css('height', (firstFlyoutHeight + 100) + 'px');
                }
            }
        });
        $('#site-navigation li.has-products ul li .item').on('hover', function(){
            $(this).siblings('.item').removeClass('active');
            $(this).addClass('active');

            var flyoutHeight = $(this).children('.flyout').height();

            if(flyoutHeight > productHeight){
                $(this).parents('.sub-menu').css('height', (flyoutHeight + 100) + 'px');
            }else{
                $(this).parents('.sub-menu').css('height', (productHeight + 100) + 'px');
            }
        });
    }

    function stickyNav(){
        var scroll = $(window).scrollTop(),
            headerTop = ( viewportwidth < 1024 ) ? '40' : '40',
            mobile = ( viewportwidth < 768 ) ? true : false,
            size = $('#main-header .header__main').outerHeight(true),
            bodyMargin = parseInt(headerTop) + parseInt(size) + 'px';

        //alert($bodyMargin);

        if (scroll > headerTop) {

            $('.header__main').addClass('sticky');
            $('.header__logo').addClass('is-stuck');

        } else {

            $('.header__main').removeClass('sticky');
            $('.header__logo').removeClass('is-stuck');

        }
    };

    // Create tour for circle graphic
    function initSimonSays() {
        var simon = $('.simon'),
            steps = $('.simon__step'),
            start = $('#start'),
            startOver = $('#startOver'),
            controls = $('.simon__controls'),
            stepNext = $('#stepNext'),
            stepPrev = $('#stepPrev'),
            pathGroup = $('.simon__group'),
            path = $('.simon__circle'),
            current = 0,
            maxHeight = 0;


        /* Animate the paths - Commented out because of IE

        path.each(function() {
            var length = this.getTotalLength();

            // Clear any previous transition
            this.style.transition = this.style.WebkitTransition =
              'none';

            // Set up the starting positions
            this.style.strokeDasharray = length + ' ' + length;
            this.style.strokeDashoffset = length;

            // Trigger a layout so styles are calculated & the browser
            // picks up the starting position before animating
            this.getBoundingClientRect();

            // Define our transition
            this.style.transition = this.style.WebkitTransition =
              'stroke-dashoffset 2.5s ease-in-out';

            // Go!
            this.style.strokeDashoffset = '0';
        }); */


        steps.hide().first().show();
        controls.hide();

        $('#start, #startOver, #stepNext').on('click', function() {
            pathGroup.addClass('out');
            controls.hide();
            steps.eq(current).fadeOut().removeClass('active').addTemporaryClass('active-out', 1250);
            pathGroup.eq(current-1).addClass('out').removeClass('in');
            current = (current + 1 < steps.length) ? current + 1 : 0;
            steps.eq(current).delay(400).fadeIn().addClass('active');
            pathGroup.eq(current-1).addClass('in').removeClass('out');
            controls.show();

            if (current == 0 || current == steps.length - 1) {
                controls.hide();
                pathGroup.removeClass('out');
            }

        });

        stepPrev.on('click', function() {
            steps.eq(current).fadeOut().removeClass('active').addTemporaryClass('active-out', 1250);
            pathGroup.eq(current-1).addClass('out').removeClass('in');
            current = (current > 0) ? current - 1 : steps.length - 1;
            pathGroup.eq(current-1).addClass('in').removeClass('out');
            steps.eq(current).delay(400).fadeIn().addClass('active');

            if (current == 0 || current == steps.length - 1) {
                controls.hide();
                pathGroup.removeClass('out');
            }

            console.log(current);
        });

    }

    function jumpLinks(){

        var scrollTop = $(window).scrollTop(),
            size = $('#main-header .header__main').outerHeight(true),
            position = $('#jumplink_trigger').position().top - size;


        if (scrollTop > position) {
            $('.nav--jumplinks').addClass('is-fixed').css('top', size);
            $('#jumplink_trigger').css('min-height', '65px');
        } else {
            $('.nav--jumplinks').removeClass('is-fixed').css('top','');
            $('#jumplink_trigger').css('min-height', '0');
        }

        function jumpLinkScroll(event){
            var scrollPos = $(document).scrollTop(),
                jumplinkWrap = $('.nav--jumplinks').outerHeight(true),
                margin = size + jumplinkWrap;

            $('.nav--jumplinks a').each(function () {
                var currLink = $(this);
                var refElement = $(this).attr("href");

                if ($(refElement).position().top <= scrollPos + margin && $(refElement).position().top + $(refElement).height() > scrollPos) {

                    $('.nav--jumplinks a').removeClass("active");
                    currLink.addClass("active");
                }
                else{
                    currLink.removeClass("active");
                }
            });
        }

        jumpLinkScroll();
    };

    function smoothScrollClick(){

        $('a[href^="#"]').not('#gated_toggle, .gated-content-toggle-btn').on('click', function (event) {

            var lity_attr = $(this).attr('data-lity');
            if (typeof lity_attr !== typeof undefined && lity_attr !== false) {
                event.preventDefault();
                $(document).off("scroll");

                $('a').each(function () {
                    $(this).removeClass('active');
                })
                $(this).addClass('active');

                var target = this.hash,
                    target = $(target),
                    header = $('#main-header .header__main').outerHeight(true),
                    jumplinkWrap = $('.nav--jumplinks').outerHeight(true),
                    test_margin = header + jumplinkWrap,
                    menu = target;

                    console.log(test_margin);

                    $('html, body').stop().animate({
                        'scrollTop': target.offset().top -test_margin
                    }, 500, 'swing', function () {

                });
            }

        });
    }


    var partnerwidth,
        partneralign,
        partnerblockalign,
        partnerleftalign,
        partnerparentwidth;
    /*function gridAccordion(){
        $('.grid_accordion_block').find('.grid_accordion_block--trigger').on('click', function(e) {

            e.preventDefault();
            partnerwidth = $('.grid_accordion .wrapper').width();
            partneralign = $('.grid_accordion').position().left;
            partnerblockalign = $(this).parent().position().left;
            partnerleftalign = partneralign - partnerblockalign;

            partnerparentwidth = ($(this).parent().width() / 2) + partnerblockalign - 15;

            if($(this).parent().hasClass('active')){
                $(this).parent().removeClass('active');
                $(this).siblings('.grid_accordion_block--content').css('width', '0');
            }else{
                $('.grid_accordion_block').removeClass('active');
                $('.grid_accordion_block--inner').css('opacity', '0');

                $(this).parent().toggleClass('active');
                $(this).siblings('.grid_accordion_block--content').css({
                    'width' : partnerwidth,
                    'left' : partnerleftalign
                }).find('.grid_accordion_block--inner').animate({opacity: "1"}, 150);
                $(this).siblings('.grid_accordion_block--content').find('.grid_accordion_block--arrow').css('left',partnerparentwidth);
            }

            $('.grid_accordion_block--close').on('click', function() {
                $('.grid_accordion_block').removeClass('active');
                $(this).parent('.grid_accordion_block--content').css('width', '0');
            });

        });
    }*/
    function gridAccordionResize(){
        if ( ! $('body').hasClass('page-template-partners-list') ) {
            if($('.grid_accordion').length && $('.grid_accordion_block.active').length){
                partnerwidth = $('.grid_accordion .wrapper').width();
                partneralign = $('.grid_accordion').position().left;
                partnerblockalign = $('.grid_accordion_block.active').position().left;
                partnerleftalign = partneralign - partnerblockalign;

                partnerparentwidth = ($('.grid_accordion_block.active').width() / 2) + partnerblockalign - 15;

                $('.grid_accordion_block.active').find('.grid_accordion_block--content').css({
                    'width' : partnerwidth,
                    'left' : partnerleftalign
                });

                $('.grid_accordion_block.active').find('.grid_accordion_block--arrow').css('left',partnerparentwidth);
            }
        }
    }

    function countrySwitcher(){
        if (viewportwidth >= 1024 && $('.country-switcher').length) {
            $('.sidr .country-switcher').removeClass('active');
            $('.country-switcher').hover(
                function () {
                    $('.country-switcher__dropdown', this).stop().slideDown(300);
                },
                function () {
                    $('.country-switcher__dropdown', this).stop().slideUp(300);
                }
            );
        }
        if (viewportwidth < 1024 && $('.sidr .country-switcher').length) {
            //added the off click so on mobile event doesn't fire twice.
            $('.sidr .country-switcher').off('click').on('click',function(){
                $(this).toggleClass('active');
                $('.sidr .country-switcher__dropdown').toggleClass('active');
            });
        }
    }

    /*
     *
     * Equal Height jQuery Snippet.  Using this for footer and grid accordion
     *
     */
    var equalheight = function (container){
        var currentTallest = 0,
            currentRowStart = 0,
            rowDivs = [],
            $el,
            topPosition = 0,
            currentDiv;

        $(container).each(function () {
            $el = $(this);
            $el.height('auto');
            topPosition = $el.position().top;
            if (currentRowStart < topPosition - 1 || currentRowStart > topPosition + 1) {
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    rowDivs[currentDiv].height(currentTallest);
                }
                rowDivs = [];
                currentRowStart = topPosition;
                currentTallest = $el.height();
                rowDivs.push($el);
            }
            else {
                rowDivs.push($el);
                currentTallest = Math.max(currentTallest, $el.height());
            }
        });

        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].css('height', currentTallest);
        }
    };

    function initSidr() {
        // $('#responsive-menu-button').sidr({
        //     name: 'sidr--main',
        //     displace: false,
        //     source : function() {
        //         return '<div class="sidr--search">' + $('.header__search').html() + '</div><div class="sidr--inner">' + $('#site-navigation').html() + '</div><div class="sidr--subnav"><ul>' + $('.nav--sub ul').html() + '</ul></div><div class="sidr--close"><button class="btn btn--secondary close"><span>Close Menu</span></button></div>';
        //     }
        // });

        // $('.sidr .mega-menu li ul').hide();
        // $('.sidr .mega-menu li .flyout').hide();
        // $('.sidr .mega-menu li').has('ul').prepend('<span class="mmenu_nested"><span class="screen-reader-text">Expand Navigation</span></span>');
        // $('.sidr .mega-menu li .item').has('.flyout').prepend('<span class="mmenu_nested"><span class="screen-reader-text">Expand Navigation</span></span>');
        // $('.sidr .mega-menu li .mmenu_nested').click(function() {
        //     $(this).parent().toggleClass('open');
        //     $(this).parent().children('ul').slideToggle();
        //     $(this).parent().children('.flyout').slideToggle();
        //     $(this).toggleClass('open');
        //         //return false;

        // });

        // $('.sidr--close .close').click(function() {
        //     $.sidr('close','sidr--main');
        //     $('#responsive-menu-button').removeClass('is-active');
        // });
    }

    function searchTrigger(){
        $("#searchTrigger").on('click',function() {
            $('.header__search').toggleClass( "focused" );
        });
    }

    function productDetailHero() {
        if(viewportwidth > 960) {
            var topHeight = $('.hero--product--top').height(),
                bottomHeight = topHeight * -.6;
            $('.hero--product--bottom').css('margin-top', bottomHeight);
        } else {
            $('.hero--product--bottom').css('margin-top', 'inherit');
        }
    }

    function postToggle(){
        if($('.post_filter_toggle').length){
            $('.post_filtering_wrap').addClass('toggle--grid-view');

            $('.post_filter_toggle .toggle').on('click',function(){

                //remove active from sibling button just in cass
                $(this).addClass('active').siblings().removeClass('active');

                //if current button is list view, add list-view class to parent wrapper
                if($(this).hasClass('toggle--list-view')){
                    $(this).parents('.post_filtering_wrap').removeClass('toggle--grid-view').addClass('toggle--list-view');
                }

                //if current button is grid view, add grid-view class to parent wrapper
                if($(this).hasClass('toggle--grid-view')){
                    $(this).parents('.post_filtering_wrap').removeClass('toggle--list-view').addClass('toggle--grid-view');
                }

                //for blog layout, remove l--col-1-4 class if in list view, then add it again if in grid view
                /*if($(this).parents('.post_filtering_wrap').data("id") === 'blog_list'){
                    if($(this).hasClass('toggle--list-view')){
                        $(this).parents('.post_filtering_wrap').find('.grid__item').removeClass('xl--col-1-4');
                    }else{
                        $(this).parents('.post_filtering_wrap').find('.grid__item').addClass('xl--col-1-4');
                    }
                }*/
            });
        }
    }

    function footerFilterTrigger(){
        //Resources Footer
        if(window.location.hash) {

            //smooth scroll up and change filter
            if (window.location.hash.indexOf('filter_') != -1) {
                var target = $('#resource_listing');
                var currentHash = window.location.hash;
                var filterName = currentHash.slice(8);

                $("select[name='post_filter[resource_type]']").val(filterName).change();

                //$('html, body').animate({ scrollTop: 0 }, 'fast');
                $('html,body').animate({
                    scrollTop: target.offset().top
                }, 800);

            }
        }
    }

    function mapClick() {
        if(viewportwidth > 960) {
            $('.block-map').mouseenter(function () {
                var $this = $(this);
                $(this).data('timeout', setTimeout(function() {
                    $this.find('iframe').addClass('active');
                }, 1000));
            }).mouseleave(function () {
                var $this = $(this);
                clearTimeout($(this).data('timeout'));
                $this.find('iframe').removeClass('active');
            });
        }
    }


    /* Document Ready */
    $(document).ready(function() {
        getWindowSize();
        equalheight('.vertical_center');
        $('input, textarea').placeholder();

        //main nav
        stickyNav();
        initMobile();
        initSidr();
        mapClick();

        countrySwitcher();
        productDetailHero();
        smoothScrollClick();
        // initScrollAnimations();

        initSimonSays();

        initSlider();
        if ( ! $('body').hasClass('page-template-partners-list') ) {
            gridAccordion();
        }

        searchTrigger();
        postToggle();

        if($('#gated_embed').length){
            $('#gated_toggle').on('click',function(e){
                e.preventDefault();
                $('#gated_embed').slideToggle(500);
                $('.callout--gated').delay( 800 ).toggleClass('open');
            });
            $('#gated_close').on('click',function(e){
                $('#gated_embed').slideToggle(500);
                $('.callout--gated').delay( 800 ).toggleClass('open');
            });
        }

        if ( $('.gated-content').length > 0 ) {
            $(document).on('click','.gated-content-toggle-btn',function(e) {
                e.preventDefault();
                var id = $(this).attr('href');
                if ( $(id).length > 0 ) {
                    $(id).slideToggle(500);                    
                    $('.callout--gated').delay( 800 ).toggleClass('open');
                    if ( $(id).find('.encoded_form_content').length > 0 ) {
                        var form_content = $(id).find('.encoded_form_content');
                        try {
                            form_json = form_content.text();
                            form_json = JSON.parse( form_json );
                            form_content.empty().html(form_json.fc).removeClass('encoded_form_content');
                            var iframe_cls_ext = id.replace("#", "");
                            form_content.find('iframe').addClass(iframe_cls_ext).removeAttr('height');

                            iFrameResize({ 
                              log: false,
                              autoResize: false,
                              checkOrigin: false,
                              heightCalculationMethod : 'max',
                              onInit : function(iframe){
                                $('.gated-content').hide().css('opacity', 1);
                                $('.js-show-form.not-loaded').hide().removeClass('not-loaded');
                              },
                            }, '.' + iframe_cls_ext);
                            form_content.removeAttr('style');
                        } catch(err) {
                            console.warn(err)
                        }
                    }
                }
            });

            $('.pardot_embed__close').on('click',function(e){
                var id = $(this).attr('data-id');
                $('#'+id).slideToggle(500);
                $('.callout--gated').delay( 800 ).toggleClass('open');
            });

        }

        // Create browser compatible event handler.
        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
        // Listen for a message from the iframe.
        eventer(messageEvent, function(e) {
          if (isNaN(e.data)) { return; }

          // replace #sizetracker with what ever what ever iframe id you need
          jQuery('iframe').each(function(){
            if(jQuery(this).is(':visible')){
                jQuery(this)[0].style.height = e.data + 'px';
            }
          });
        }, false);



        $('#responsive-menu-button').on('click touchstart',function() {
            $(this).toggleClass('is-active');
        });

        //jump links
        if($('#jumplink_trigger').length){
            jumpLinks();
        }

        $('.newsletter-popup').magnificPopup({
            type: 'inline',
            preloader: false,
        });


        //sorting function on clients page
        $('.js-auto-submit').on('change',function(){
            $(this).parents('form').submit();
        });
        //listen for filter changes on clients/partners pages
        $('.js-filter-form').on('change','.js-filter-filter',function(){
            var items = $('.js-filter-item').show();

            if($(this).val() == ''){
                return;
            }

            var filter_class = '.'+$(this).attr('name') + '-' + $(this).val();
            items.not(filter_class).hide();
        });

        footerFilterTrigger();

    });

    $(window).scroll(function() {
        stickyNav();

        if($('#jumplink_trigger').length){
            jumpLinks();
        }
    });

     $(window).load(function(){
         $("#loader").fadeOut("slow");
     });


    $(window).on("resize", function() {
        getWindowSize();
        equalheight('.vertical_center');
        if ( ! $('body').hasClass('page-template-partners-list') ) {
            gridAccordionResize();
        }
        productDetailHero();
        countrySwitcher();


    });

    $(window).on('hashchange', function() {
        footerFilterTrigger();
    });

})(jQuery);

function gridAccordion(){
    var $ = jQuery;
    $(document).find('section.mri-app-integration-module .card.card--accordion').matchHeight({byRow: false});
    var $trigger = $('.grid_accordion_block').find('.grid_accordion_block--trigger');
    $trigger.off('click');
    $trigger.on('click', function(e) {
        e.preventDefault();
        $('.grid_accordion_block--close').trigger('click');
        var partnerwidth = $('.grid_accordion .wrapper').width(),
            partneralign = $('.grid_accordion').position().left,
            partnerblockalign = $(this).closest('.grid_accordion_block').position().left,
            partnerleftalign = partneralign - partnerblockalign,
            partnerparentwidth = ($(this).closest('.grid_accordion_block').width() / 2) + partnerblockalign - 15,
            itemHeight = $(this).height() - 80;
        var slug = $(this).attr('data-slug');

        if( $(this).closest('.grid_accordion_block').hasClass('active')){
            $(this).closest('.grid_accordion_block').removeClass('active');
            $(this).closest('.grid_accordion_block').find('.grid_accordion_block--content').css('width', '0');
            if ( $('body').hasClass('page-template-team-list') ) {
                history.pushState(null, null, mri_moove_scripts.permalink);
            }
        }else{

            $(this).closest('.grid_accordion_block').removeClass('active');
            $(this).closest('.grid_accordion_block').find('.grid_accordion_block--inner').css('opacity', '0');

            //scroll to top of active block
            $(this).closest('.grid_accordion_block').toggleClass('active');
            if ( $('body').hasClass('page-template-team-list') ) {
                history.pushState(null, null, mri_moove_scripts.permalink + slug );
            }
            $("body, html").animate({
                scrollTop: $('.grid_accordion_block.active').offset().top + itemHeight
            });

            $(this).closest('.grid_accordion_block').find('.grid_accordion_block--content').css({
                'width' : partnerwidth,
                'left' : partnerleftalign
            }).find('.grid_accordion_block--inner').animate({opacity: "1"}, 150);
            $(this).closest('.grid_accordion_block').find('.grid_accordion_block--content').find('.grid_accordion_block--arrow').css('left',partnerparentwidth);
        }

        $('.grid_accordion_block--close').on('click', function() {
            $(this).closest('.grid_accordion_block').removeClass('active');
            $(this).parent('.grid_accordion_block--content').css('width', '0');
            if ( $('body').hasClass('page-template-team-list') ) {
                history.pushState(null, null, mri_moove_scripts.permalink);
            }
        });

    });
}